import cmsAbstractMixin from 'framework/mixins/cms/cms-abstract';


export default {
    mixins: [
        cmsAbstractMixin,
    ],
    data() {
        return {
            cmsCfg: {
                watchPath: 'cms',
                type: 'placeholder',
            },
        };
    },
};
